import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {KortSamlingKomponent} from "web-ng2/delt/komponenter/kort/kort-samling/kort-samling";
import {GruppeSakstyperKomponent} from "../gruppe-sakstyper/gruppe-sakstyper";
import {GruppeRollerKomponent} from "../gruppe-roller/gruppe-roller";
import {GruppeTemaerKomponent} from "../gruppe-temaer/gruppe-temaer";
import {ÅrshjulOppsettKomponent} from "web-ng2/moduler/årshjul/komponenter/årshjul-oppsett/årshjul-oppsett";
import {AksjeklasserKomponent} from "web-ng2/moduler/aksjeklasse/komponenter/aksjeklasser/aksjeklasser";
import {GruppeProtokollOppsettKomponent} from "web-ng2/moduler/gruppe/komponenter/gruppe-protokoll-oppsett/gruppe-protokoll-oppsett";
import {GruppeModellDML} from "felles-ng2/tjenester/datalager/GruppeDatatjeneste";

@Component({
    selector: 'gruppe-konfigurasjon',
    templateUrl: 'gruppe-konfigurasjon.html',
    styleUrl: 'gruppe-konfigurasjon.scss',
    host: {'data-testid': 'gruppe-konfigurasjon'},
    imports: [
        KortSamlingKomponent,
        GruppeSakstyperKomponent,
        GruppeRollerKomponent,
        GruppeTemaerKomponent,
        ÅrshjulOppsettKomponent,
        AksjeklasserKomponent,
        GruppeProtokollOppsettKomponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GruppeKonfigurasjonKomponent {
    static ajsSelector = 'gruppeKonfigurasjon';

    gruppe = input.required<GruppeModellDML>();
}
